export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';
export const SIGNUP_MAGICLINK_SUCCESS = 'SIGNUP_MAGICLINK_SUCCESS';
export const SIGNUP_MAGICLINK_FAILURE = 'SIGNUP_MAGICLINK_FAILURE';
export const SIGNUP_VALIDATION_FAILURE = 'SIGNUP_VALIDATION_FAILURE';
export const SIGNUP_COUPON_FAILURE = 'SIGNUP_COUPON_FAILURE';
